export interface PaginationModel {
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
  id: string;
}

export class PaginationClass {
  private _currentPage: number;
  private _itemsPerPage: number;
  private _totalItems: number;
  private _offset: number;
  private readonly _id: string;

  constructor(id: string, itemsPerPage: number = 10, offset: number = 0) {
    this._id = id;
    this.resetPagination(itemsPerPage, offset);
  }

  getPaginationModel(): PaginationModel {
    return {
      currentPage: this._currentPage,
      itemsPerPage: this._itemsPerPage,
      totalItems: this._totalItems,
      id: this._id
    }
  }

  resetPagination(itemsPerPage: number = 10, offset: number = 0): PaginationModel {
    this._currentPage = 1;
    this._itemsPerPage = itemsPerPage;
    this._offset = offset;
    return this.getPaginationModel();
  }

  changePage(newPage: number): PaginationModel {
    this._currentPage = newPage;
    this._offset = (newPage - 1) * this._itemsPerPage;
    return this.getPaginationModel();
  }

  updateTotalItems(itemsFoundLength: number): PaginationModel {
    // Update totalItems to enable pagination - assume more data if we get full page
    this._totalItems = Math.max(
      this._itemsPerPage,
      this._offset + itemsFoundLength + (itemsFoundLength === this._itemsPerPage ? this._itemsPerPage : 0)
    );
    return this.getPaginationModel();
  }

  get currentPage(): number {
    return this._currentPage;
  }

  get itemsPerPage(): number {
    return this._itemsPerPage;
  }

  get offset(): number {
    return this._offset;
  }

  get id(): string {
    return this._id;
  }
}
